import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { CheckCircle2, XCircle } from "lucide-react";
import { api, formatXAF } from "@/lib/api";
import { useI18n } from "@/i18n/I18nContext";

const Check = ({ ok, label, testid }) => (
  <p className="flex items-center gap-2 text-sm" data-testid={testid}>
    {ok ? <CheckCircle2 className="h-4 w-4 text-emerald-400" /> : <XCircle className="h-4 w-4 text-red-400" />} {label}
  </p>
);

export default function LudoVerifyPage() {
  const { id } = useParams();
  const { t } = useI18n();
  const { data, isError } = useQuery({ queryKey: ["ludo-verify", id], queryFn: () => api.get(`/ludo/verify/${id}`).then((r) => r.data), retry: false });
  if (isError) return <p className="text-sm text-slate-400" data-testid="ludo-verify-error">{t("ludo.verifyNotReady")}</p>;
  if (!data) return null;
  return (
    <div className="surface mx-auto max-w-xl space-y-3 p-6 rise" data-testid="ludo-verify-page">
      <h1 className="font-display text-2xl font-extrabold">{t("ludo.verify")}</h1>
      <p className="font-mono text-xs text-slate-400">{data.game_id}</p>
      <Check ok={data.seed_hash_ok} label={t("ludo.vHash")} testid="ludo-verify-hash" />
      <Check ok={data.dice_ok} label={`${t("ludo.vDice")} (${data.rolls})`} testid="ludo-verify-dice" />
      <Check ok={data.board_ok} label={t("ludo.vBoard")} testid="ludo-verify-board" />
      <p className="text-sm">{t("ludo.winner")} {data.winners.map((w) => data.pseudos[w]).join(", ")} · {formatXAF(data.settlement?.share || 0)}</p>
      <p className="break-all text-[11px] text-slate-500">seed: {data.seed}</p>
      <p className="break-all text-[11px] text-slate-500">sha256: {data.seed_hash}</p>
    </div>
  );
}
